import React from 'react';
import './IdleTimeoutDialog.css';

interface IdleTimeoutDialogProps {
  secondsLeft: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

function formatTime(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

/**
 * IdleTimeoutDialog — mirrors Angular's idle-timeout-dialog.component.
 *
 * Shows "Are you still here?" with countdown and two buttons:
 *  - "Log Me Out"
 *  - "Keep Me Signed In"
 */
export const IdleTimeoutDialog: React.FC<IdleTimeoutDialogProps> = ({
  secondsLeft,
  onStayLoggedIn,
  onLogout,
}) => {
  return (
    <div className="idle-timeout-overlay">
      <div className="idle-timeout-modal">
        <span className="idle-timeout-title">Are you still here?</span>
        <div className="idle-timeout-content">
          <p className="idle-timeout-message">
            In order to keep your information safe, you will be logged out after 30 minutes of inactivity.
          </p>
          <p className="idle-timeout-message idle-timeout-elapse">
            Your current session will expire in{' '}
            <span className="idle-timeout-time">{formatTime(secondsLeft)}</span>
          </p>
        </div>
        <div className="idle-timeout-actions">
          <button
            type="button"
            className="idle-timeout-btn idle-timeout-btn-logout"
            onClick={onLogout}
          >
            Log Me Out
          </button>
          <button
            type="button"
            className="idle-timeout-btn idle-timeout-btn-stay"
            onClick={onStayLoggedIn}
          >
            Keep Me Signed In
          </button>
        </div>
      </div>
    </div>
  );
};
